import Handlebars from 'handlebars';
import 'extension';

/**
 * @example: {{culture 'generic.EMPTY_LIGHTBOX'}}
 */
Handlebars.registerHelper('culture', function (context) {
  let rv = app.culture;
  const aPath = context.split('.');

  _.each(aPath, function (property) {
    rv = rv[property];
  });

  return rv;
});

Handlebars.registerHelper('testRegExp', function (target, regexp, options) {
  const rgTest = new RegExp(regexp, 'i');

  if (rgTest.test(target)) {
    return options.fn(target);
  } else {
    return options.inverse(target);
  }
});

Handlebars.registerHelper('ifCond', function (v1, v2, options) {
  if (v1 == v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});

/**
 * Print first non empty string argument, prepending protocol
 **/
Handlebars.registerHelper('src', function () {
  const argLength = arguments.length - 1; // excluding last argument (context)
  for (let i = 0, I = argLength; i < I; i++) {
    // eslint-disable-next-line prefer-rest-params
    if (!_.isEmpty(arguments[i])) {
      // eslint-disable-next-line prefer-rest-params
      return app.prependHttp(String(arguments[i]));
    }
  }
  return '';
});

Handlebars.registerHelper('isProd', function (context, options) {
  if (app.rootStore.getters['user/box'].isProd()) {
    return options.fn(context);
  } else {
    return options.inverse(context);
  }
});

Handlebars.registerHelper('isDev', function (context, options) {
  if (app.rootStore.getters['user/box'].isDev()) {
    return options.fn(context);
  } else {
    return options.inverse(context);
  }
});

Handlebars.registerHelper('printDateTime', function (dateLong) {
  return dateLong ? app.moment(dateLong).format('MM/DD/YYYY hh:mma') : '';
});

Handlebars.registerHelper('select', function (value, options) {
  const $el = $('<select />').html(options.fn(this));
  $el.find('[value="' + value + '"]').attr({ selected: 'selected' });
  return $el.html();
});
